export default "__VITE_ASSET__Rp$_8JM$__"